<template>
  <div>
    <div class="return-btn">
      <gj-button
          type="text"
          @click="returnPackage">
        &#60;返回套餐详情
      </gj-button>
    </div>
    <div class="order-wrapper">
      <div class="package--title">
        <gj-icon iconfont="icondingdanxiangqing" class="title--icon"></gj-icon>
        订单详情
      </div>
      <el-divider class="divider"></el-divider>
      <div class="order-project">
        <gj-table
            :index="false"
            name="packageOrderInfo"
            :data="tableData"
            :columns="columns"
            :adaptHeight="false"
            :show-pagination="false"
            border>
          <template v-slot:price="{ row }">
            <span class="project--price">￥{{amount(row.price)}}</span>
          </template>
          <template v-slot:orderNumber="{ row }">
<!--            <span>{{row.orderNumber > 10000?row.orderNumber/10000 + '万单':row.orderNumber + '单'}}</span>-->
            <span>{{row.orderNumber + fuelPackTypes[row.fuelPackType]}}</span>
          </template>
        </gj-table>
        <div class="order-project--total" style="text-align: right;">
          <span class="order-project--total-text">总计</span>
          <span class="order-project--total-number">￥{{amount(sumFee)}}</span>
        </div>
      </div>
      <div class="pay-info">
        <div class="pay-type">请选择支付方式</div>
        <div class="pay-alert">
          <ul>
            <li style="margin-bottom: 4px;">套餐购买不支持退货、转移到其他账号，付款前请仔细核对订单信息</li>
            <li>如需申请开票，可联系专属软件顾问或客服。（客服QQ：2853361882；客服微信：18126251595）</li>
          </ul>
        </div>
        <el-row
            type="flex"
            justify="center"
            :gutter="20"
            class="pay-cards">
          <div
              v-for="item in payTypes"
              :key="item.id"
              :class="['pay-card', payType === item.id ? 'active' : '']"
              @click="choosePayType(item.id)">
            <gj-icon :iconfont="item.icon" class="pay-icon"></gj-icon>
            <span class="pay-text">{{item.text}}</span>
          </div>
        </el-row>
        <el-row
            type="flex"
            justify="center">
          <div v-show="payType === 0 ">
            <div class="pay-code">
              <div class="pay-tip" style="margin-bottom: 4px">
                {{payTypes[payType].tip}}
              </div>
              <div>
                <template v-if="base64Img !== null && base64Img !== ''">
                  <img :src="base64Img" width="200px" height="200px" >
                </template>
                <template v-else>
                  <div style="width: 200px;height:200px;text-align:center;background:#fafafa;align-items:center;display:grid">
                    <span style="margin:auto">
                      二维码已过期，<el-button type="text" @click="refreshQRCode" >刷新</el-button>
                    </span>
                  </div>
                </template>
              </div>
              <div class="pay-tip"
                   style="margin-top: 4px">
                <!--完成扫描支付后，若没有自动跳转，请联系客服-->
                完成扫描支付后，<el-button type="text" @click="confirmPay('SUCCESS', false)" >请点击此处确认支付</el-button>
              </div>
            </div>
          </div>
          <div v-show="payType === 1">
            <div class="bank-info">
              <div class="switch-row">
                <span class="gj-label bank-info--title">户名：</span><span class="gj-content">{{corporateAccount.name | defaultShow}}</span>
                <gj-copy-icon :content="corporateAccount.name || ''" style="font-size: 12px;"></gj-copy-icon>
              </div>
              <div class="switch-row">
                <span class="gj-label bank-info--title">账户：</span><span class="gj-content">{{corporateAccount.account | defaultShow}}</span>
                <gj-copy-icon :content="corporateAccount.account || ''" style="font-size: 12px;"></gj-copy-icon>
              </div>
              <div><span class="gj-label bank-info--title">开户行：</span><span class="gj-content">{{corporateAccount.accountBank | defaultShow}}</span></div>
            </div>
            <div class="link-kefu">
              转账成功或有疑惑，请
              <gj-button
                  id="qq_kefu"
                  size="mini"
                  type="primary">
                联系客服
              </gj-button>
            </div>
            <div v-if="false" style="text-align: center;">
              <gj-button
                  type="primary"
                  class="bank-pay--btn"
                  @click="openPayFormModal()">
                <div style="margin-bottom: 5px;">已支付</div>
                <div>提交付款信息</div>
              </gj-button>
            </div>
          </div>
        </el-row>
      </div>
    </div>
    <gj-modal
        size="normal"
        :visible.sync="modalVisible.bankPay"
        @cancel="modalVisible.bankPay = false">
      <template #header>填写付款信息</template>
      <template #content>
        <el-form
            ref="payForm"
            :model="payForm"
            label-width="150px">
          <el-form-item
              label="付款方"
              prop="paymentName"
              :rules="[{ required: true, message: '请输入付款方', trigger: 'blur' }]">
            <gj-input
                v-model="payForm.paymentName"
                class="payer-input"
            ></gj-input>
          </el-form-item>
          <el-form-item
              label="银行名称"
              prop="bankName"
              :rules="[{ required: true, message: '请输入银行名称', trigger: 'blur' }]">
            <gj-input
                v-model="payForm.bankName"
                class="payer-input"
            ></gj-input>
          </el-form-item>
          <el-form-item
              label="银行账号"
              prop="bankAccount"
              :rules="[{ required: true, message: '请输入银行账号', trigger: 'blur' }]">
            <gj-input
                v-model="payForm.bankAccount"
                class="payer-input"
            ></gj-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
         <gj-button
             type="primary"
             :loading="submitPayInfoLoading"
             @click="submitPayInfo">
           确定
         </gj-button>
      </template>
    </gj-modal>
  </div>
</template>

<script>
  import {queryCorporate,saveCorporate,alipayRecharge,alterPayStatus,refreshQRCode} from "../../../../../api/setting";
  import {RESPONSE_CODE} from "@/utils/const";
  import {isMeaningful} from "@/utils/common";
  import {amount} from "../../../../../filters";
  import {kefuMixin} from "@/minxins";

  export default {
    name: "app-package-order",
    mixins: [kefuMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'content', header: '购买项目', field: 'content', minWidth: '50px'},
          {id: 'orderNumber', header: '数量', field: 'slot:orderNumber', minWidth: '50px'},
          {id: 'price', header: '价格', field: 'slot:price', minWidth: '50px'}
        ],
        sumFee: 0,
        submitPayInfoLoading: false,
        payType: 0,
        payTypes: [
          //{id: 0, text: '微信支付', icon: 'iconweixinzhifu', tip: '请用微信扫描以下二维码进行支付'},
          {id: 0, text: '支付宝', icon: 'iconumidd17', tip: '请用支付宝扫描以下二维码进行支付'},
          {id: 1, text: '对公转账', icon: 'iconyinhangka', tip: ''},
        ],
        corporateAccount:{
          name: '',
          account: '',
          accountBank: ''
        },
        payForm: {
          paymentName: null,
          bankName: null,
          bankAccount: null
        },
        modalVisible: {
          bankPay: false
        },
        attachmentsId: null,//二维码支付图片id
        outTradeNo: null,//订单号
        payAmount: 0,//充值金额
        base64Icon: 'data:image/png;base64,',
        base64Img: '',
        amount: amount,
        kefuLink: 'https://wp.qiye.qq.com/qidian/3009000551/9be693d509bf926ac8eea793c9416f60',
        fuelPackTypes:{
          '0': '单',
          '1': '封',
          '2': '',
          '3': '',
          '4': '积点',
        }
      }
    },
    props: ['proInfo'],
    created() {
      const tableData = []
      //固定套餐
      var fixedPackageObj = this.proInfo.fixedPackageObj;
      if(fixedPackageObj !== null && fixedPackageObj !== ''){
        tableData.push({
          content: '固定套餐',
          fuelPackType: 0,
          orderNumber: fixedPackageObj.orderNum,
          price: fixedPackageObj.priceSum,
          packageId: this.proInfo.fixedPackageObj.id,
          fuelPackId: 0,
        })
      }
      // 邮件加油包
      if (isMeaningful(this.proInfo.emailPackageObj)) {
         tableData.push({
          content: '邮件加油包',
          fuelPackType: 1,
          orderNumber: this.proInfo.emailPackageObj.number,
          price: this.proInfo.emailPackageObj.priceSum,
          packageId: 0,
          fuelPackId: this.proInfo.emailPackageObj.id,
        })
      }
       // 积点
      if (isMeaningful(this.proInfo.currencyPackageObj)) {
         tableData.push({
          content: '积点',
          fuelPackType: 4,
          orderNumber: this.proInfo.currencyPackageObj.number,
          price: this.proInfo.currencyPackageObj.priceSum,
          packageId: 0,
          fuelPackId: this.proInfo.currencyPackageObj.id,
        })
      }
      // if(isMeaningful(this.proInfo.orderPackageType)){
      //   let selfDefinesObj = this.proInfo.selfDefines.find(item => item.id === this.proInfo.orderPackageType)
      //   tableData.push({
      //     content: '邮件加油包',
      //     fuelPackType: 1,
      //     orderNumber: selfDefinesObj.orderNumber,
      //     price: selfDefinesObj.price,
      //     id: null
      //   })
      // }
      // // 工具加油包
      // if(isMeaningful(this.proInfo.selfDefinesArr)){
      //   this.proInfo.selfDefinesArr.forEach(item => {
      //     if (item.num > 0) {
      //       tableData.push({
      //         content: `工具加油包-${item.fuelPackType === 2 ? '关键字监控':'跟卖监控'}`,
      //         fuelPackType: item.fuelPackType,
      //         orderNumber: Number(item.orderNumber) * Number(item.num),
      //         price: item.amount,
      //         id: null
      //       })
      //     }
      //   });
      // }


      this.tableData = tableData
      this.sumFee = this.proInfo.sumFee

      // 生成充值记录 及 支付二维码
      const param = {
        payType: 'ZFB',
        orderDetails: tableData.map(e => {
          return {
            packageId: e.packageId,
            fuelPackId: e.fuelPackId,
            fuelPackType: e.fuelPackType,
            content: e.content,
            number: e.orderNumber,
            amount: e.price,
          }
        }),
        amount: this.sumFee,
      }

      //生成充值记录及获取二维码
      alipayRecharge(param).then(response => {
        if(response.isSuccess){
          let Base64 = require('js-base64').Base64;
          this.base64Img = this.base64Icon +Base64.decode(response.data.base64Img)
          this.payAmount = response.data.payAmount
          this.outTradeNo = response.data.outTradeNo
          this.imgLoseEfficacy();
          this.checkPay();
        }
      });

      // 查询对公账户
      queryCorporate().then(response => {
        if (response.isSuccess) {
          this.corporateAccount = response.data || {};
        }
      });
      this.$on('hook:destroyed', () => {
        this. y7();
      });
    },
    methods: {
      choosePayType(type) {
        this.payType = type;
      },
      submitPayInfo() {
        this.$refs.payForm.validate((valid) => {
          if (valid) {
            this.submitPayInfoLoading = true;
            const params = {
              bankName: this.payForm.bankName,
              bankAccount: this.payForm.bankAccount,
              paymentName: this.payForm.paymentName,
              payType: 'ZZ',
              amount: this.sumFee,
              orderDetails: this.tableData.map(e => {
                return {
                  packageId: e.packageId,
                  fuelPackId: e.fuelPackId,
                  fuelPackType: e.fuelPackType,
                  content: e.content,
                  number: e.orderNumber,
                  amount: e.price,
                }
              })
            }
            saveCorporate(params).then(res => {
              if(res.isSuccess){
                this.closePage('我们将在近期完成付款信息的审核\n' +
                        '审核结果将体现在【充值记录】，请注意查看！','提交审核成功')
              }
            }).complete(() =>{
              this.modalVisible.bankPay = false;
              this.submitPayInfoLoading = false;
            })

          } else {
            return false;
          }
        });
      },
      refreshQRCode(){
        let Base64 = require('js-base64').Base64;
        refreshQRCode(this.outTradeNo).then(response => {
          if(response.isSuccess){
            this.base64Img = this.base64Icon + Base64.decode(response.data.base64Img)
            this.imgLoseEfficacy();
          }else{
            this.$message.error("刷新失败")
          }
        }).catch(response => {
          this.$message.error("刷新失败")
        })
      },
      resetPayForm() {
        this.$refs.payForm && this.$refs.payForm.resetFields();
      },
      checkPay() {
        this.clearCheckPayInterval();
        this.checkPayInterval = setInterval(() => {
          this.confirmPay('SUCCESS');
        }, 3000);
      },
      confirmPay(alter, auto = true) {
        // 生成充值记录 及 支付二维码
        const param = {
          payType: 'ZFB',
          outTradeNo: this.outTradeNo,
          alter: alter,
        };
        alterPayStatus(param).then(res => {
          if(res.code === RESPONSE_CODE.SUCCESS){
            this.closePage('您已成功缴费'+res.data.amount+'元，感谢您的使用！快去体验功能吧！','支付成功')
          } else {
            if (auto) {
              return;
            }
            this.$gjMessage({
              message: res.msg || '网络错误，请重试',
              type: 'error',
              duration: 3000
            }).then(()=>{
              location.reload();
            }).catch(()=>{
              this.$router.push({
                path: '/dashboard',
                query:{
                  deleteTabs: '套餐管理'
                }
              });
            })
            setTimeout(() => {
              let messageBox = document.getElementsByClassName("el-message-box__wrapper");
              let model = document.getElementsByClassName("v-modal");
              if(messageBox){
                messageBox[0].parentNode.removeChild(messageBox[0]);
                model[0].parentNode.removeChild(model[0]);
              }
              this.$router.push({
                path: '/dashboard',
                query:{
                  deleteTabs: '套餐管理'
                }
              });
            }, 5000)
          }
        }).catch(res =>{

        })
      },
      //二维码失效
      imgLoseEfficacy(){
        setTimeout(() => {
          this.clearCheckPayInterval();
          this.base64Img = null;
        }, 3 * 60 * 1000)
      },
      openPayFormModal() {
        this.resetPayForm();
        this.modalVisible.bankPay = true;
      },
      returnPackage(){
        this.$emit('return-package')
      },
      closePage(text,but,type) {
        this.$alert(text,but, {
          confirmButtonText: '返回首页',
          showConfirmButton:true,
          type: type === null?'success':type,
          center: true
        }).complete(() => {
          // this.$router.push({
          //   path: '/dashboard',
          //   query:{
          //     deleteTabs: '套餐管理'
          //   }
          // });
          window.location.href = '/';
        });
        setTimeout(() => {
          let messageBox = document.getElementsByClassName("el-message-box__wrapper");
          let model = document.getElementsByClassName("v-modal");
          if(messageBox){
            messageBox[0].parentNode.removeChild(messageBox[0]);
            model[0].parentNode.removeChild(model[0]);
          }
          this.$router.push({
            path: '/dashboard',
            query: {
              deleteTabs: '套餐管理'
            }
          });
        }, 5000);
        this.clearCheckPayInterval();
      },
      clearCheckPayInterval() {
        if (isMeaningful(this.checkPayInterval)) {
          clearInterval(this.checkPayInterval);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common.scss";

  .return-btn {
     margin-top: -10px;
  }
  .bank-pay--btn {
    width: 180px;
    padding: 5px;
    margin-top: 20px;
  }
  .order-wrapper {
    margin-top: 10px;
    background: #fff;
  }
  .project--price {
    color: $--price--color;
    font-weight: bold;
  }
  .order-project {

  }
  .order-project--total {
    text-align: right;
    margin: 12px 0 24px;
  }
  .order-project--total-text {
    margin-right: 8px;
    color: #000;
    font-size: 12px;
  }
  .order-project--total-number {
    color: $--price--color;
    font-size: 20px;
    font-weight: 700;
  }
  .pay-info {

  }
  .payer-input {
    width: 220px !important;
  }
  .pay-type {
    font-weight: 700;
    color: #000;
    font-size: 14px;
  }
  .pay-alert {
    margin: 10px 0;
    font-size: 12px;
    padding: 12px;
    color: #000;
    background-color: #fafafa;
    line-height: 16px;
  }
  .pay-cards {
    margin-top: 30px;
  }
  .pay-card {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px 22px;
    border-radius: 2px;
    border: 1px solid #ddd;
  }
  .pay-card:not(:first-child) {
    margin-left: 30px;
  }
  .pay-card.active {
    border: 1px solid #006eff;
  }
  .pay-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
  .pay-icon {
    font-size: 30px;
  }
  .pay-text {
    margin-left: 8px;
  }
  .pay-tip {
    color: #000;
    font-size: 14px;
  }
  .bank-info {
    width: 500px;
    height: 140px;
    margin-top: 30px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fafafa;
  }
  .bank-info--title {
    font-size: 14px;
    font-weight: 400;
    display: inline-block;
    width: 70px;
    line-height: 30px;
  }
  .link-kefu {
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
    color: #888;
  }
</style>
